module.exports = __webpack_public_path__ + "img/goldregen-2020-045.3020867f.jpg";